module.exports = __webpack_public_path__ + "static/media/ic_02_vpncertified.5b9ffb0c.svg";